export default __webpack_public_path__ + "static/media/search.d7fc9295.svg";